// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nrmve","inner":"Footer_inner__16_ha"};